import { sessionQuery, sessionQueryKey, type AuthDeps, type Principal } from '@esnafai/shared/auth';
import type { components } from '@esnafai/shared/api';

export type Me = components['schemas']['Me'];

// The principal of the session query /auth keeps, read once when the cache has none yet (a public route opened
// first, which the root guard does not read it for). A 401 is "not logged in".
export async function ensureSession({ api, queryClient }: AuthDeps): Promise<Me | null> {
  const principal = await queryClient.ensureQueryData(sessionQuery(api));
  return principal && 'merchant' in principal ? principal : null;
}

// The principal the root guard has already loaded, for the redirects of the routes below it.
export function cachedSession({ queryClient }: AuthDeps): Me | null {
  const principal = queryClient.getQueryData<Principal | null>(sessionQueryKey('merchant'));
  return principal && 'merchant' in principal ? principal : null;
}

/** A returnTo path of this app (never another origin), split for the router. */
export function returnTarget(returnTo: string | undefined): {
  to: string;
  search: Record<string, string>;
} {
  if (!returnTo?.startsWith('/') || returnTo.startsWith('//')) return { to: '/', search: {} };
  const url = new URL(returnTo, 'http://panel.invalid');
  return { to: url.pathname, search: Object.fromEntries(url.searchParams) };
}
